import { useApp } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import SpotlightSearch from '../search/SpotlightSearch';
import NotificationDropdown from '../common/NotificationDropdown';
import Button from '../common/Button';
import { FiMenu, FiPlus } from 'react-icons/fi';

export default function Header({ pageTitle, onMenuClick }) {
  const { openAddCompanyModal } = useApp();
  const { user } = useAuth();

  // Admins use the admin sidebar; the Add Company CTA is for corporate users.
  const isAdmin = ['admin', 'super_admin'].includes(String(user?.roleName || '').toLowerCase());

  // NOTE: the company switcher + account menu that used to live here were
  // removed — both are fully covered by the sidebar (workspace switcher for
  // company selection, profile dropup for My Profile / Sign out, and the
  // "Companies" nav item for management). Keeping them here was redundant.
  return (
    <header
      className="shrink-0 z-40 flex items-center gap-2.5 px-4 lg:px-7 py-[11px] border-b bg-white"
      style={{ borderColor: '#ddd6c6', boxShadow: '0 2px 16px rgba(8,17,31,0.07)' }}
    >
      {/* Hamburger — opens the off-canvas sidebar drawer below lg. Hidden at
          lg+ where the sidebar is permanently pinned. */}
      <button
        onClick={onMenuClick}
        className="lg:hidden flex-shrink-0 -ml-1 grid place-items-center w-9 h-9 rounded-xl border transition-colors hover:bg-[#faf7f2]"
        style={{ borderColor: '#ddd6c6', color: '#08111f' }}
        aria-label="Open menu"
      >
        <FiMenu size={17} />
      </button>

      <h1
        className="flex-1 m-0 min-w-0 text-[20px] font-bold whitespace-nowrap overflow-hidden text-ellipsis"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        {pageTitle}
      </h1>

      <SpotlightSearch />

      <NotificationDropdown />

      {!isAdmin && (
        <Button
          variant="gold"
          size="sm"
          className="group shrink-0 !h-[34px] !rounded-xl active:scale-[0.98] transition-transform"
          onClick={openAddCompanyModal}
          leftIcon={<FiPlus size={15} className="transition-transform duration-300 group-hover:rotate-90" />}
        >
          Add Company
        </Button>
      )}
    </header>
  );
}
